import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logo_black@2x.png")